import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalNumber,
} from '../shared/schema'

export const schema = z.object({
  roleName: z.string(),
  roleMin: z.number().int(),
  roleMax: z.number().int(),
  order: nullSafeOptionalNumber(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    roleName: '',
    roleMin: 0,
    roleMax: 0,
    order: 0,
  })
)

export type FirestoreSlideDeckRole = z.infer<typeof schema>
export type FirestoreSlideDeckRoleWrite = z.infer<typeof writeSchema>
